/* global axios */
import ApiClient from './ApiClient';

class NotificationSubscriptions extends ApiClient {
  constructor() {
    super('notification_subscriptions');
  }

  // BonBoZ: báo quyền thông báo + đăng ký push hiện có của máy này.
  reportDeviceStatus(data) {
    return axios.post(`${this.url}/device_status`, data);
  }

  // BonBoZ: người dùng tự tắt thông báo đẩy trên máy này.
  disable(data) {
    return axios.post(`${this.url}/disable`, data);
  }
}

export default new NotificationSubscriptions();
